export default () =>
  ({
    de: {
      'short-w-year': {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      },
      'short-wo-year': {
        month: 'long',
        day: 'numeric',
      },
      short: {
        month: 'short',
        day: 'numeric',
      },
      long: {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        weekday: 'short',
        hour: 'numeric',
        minute: 'numeric',
      },
    },
    fr: {
      'short-w-year': {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      },
      'short-wo-year': {
        month: 'long',
        day: 'numeric',
      },
      short: {
        month: 'short',
        day: 'numeric',
      },
      long: {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        weekday: 'short',
        hour: 'numeric',
        minute: 'numeric',
      },
    },
    en: {
      'short-w-year': {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      },
      'short-wo-year': {
        month: 'long',
        day: 'numeric',
      },
      short: {
        month: 'short',
        day: 'numeric',
      },
      long: {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        weekday: 'short',
        hour: 'numeric',
        minute: 'numeric',
      },
    },
  }) as const
